/*
  Keyboard Key Codes as defined by W3C
  https://www.w3.org/TR/uievents-code/#keyboard-key-codes
  Add as we go!
*/
export const ARROW_LEFT = 'ArrowLeft';
export const ARROW_RIGHT = 'ArrowRight';
export const ARROW_UP = 'ArrowUp';
export const ARROW_DOWN = 'ArrowDown';
export const BACKSPACE = 'Backspace';
export const DELETE = 'Delete';
export const ENTER = 'Enter';
export const ESCAPE = 'Escape';
export const SPACE = 'Space';
export const HOME = 'Home';
export const END = 'End';
export const PAGE_DOWN = 'PageDown';
export const PAGE_UP = 'PageUp';
export const NUMPAD_ENTER = 'NumpadEnter';
export const TAB = 'Tab';
export const ACTION_KEYS = [ENTER, NUMPAD_ENTER, SPACE];
export function isKeyCode(evt, codes) {
    if (typeof codes === 'string') {
        return evt.code === codes;
    }
    else {
        return codes.indexOf(evt.code) > -1;
    }
}
